var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-alert',{staticClass:"alert--global",attrs:{"type":_vm.CR.show.alert.type,"value":_vm.CR.show.alert.active,"transition":"slide-y-reverse-transition","dismissible":"dismissible"}},[_vm._v(_vm._s(_vm.CR.show.alert.message))]),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66630ab2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = yLWY
// module chunks = 1